module.exports = __webpack_public_path__ + "static/media/wizualizacja-34.d9cbd6e2.png";